<template>
  <v-container fluid class="request-form" id="form">
    <v-container grid-list-lg>
        <v-form ref="form" v-model="valid" @submit.prevent="handleFormSubmit" @keyup.native.enter="submit($event)">
            <v-layout>
                <v-flex xs12>
                    <v-card flat>
                        <v-card-text class="form-body">
                            <h3 class="secondary--text text-h5">Vyplňte formulář a&nbsp;karta je vaše ...</h3>
                            <v-text-field
                                    color="secondary"
                                    v-model="form.email"
                                    label="E-mail"
                                    :rules="[rules.required, rules.email]"
                                    type="email"
                                    :error-messages="errors.email"
                            ></v-text-field>
                            <v-text-field
                                    color="secondary"
                                    label="Jméno"
                                    v-model="form.firstName"
                                    :rules="[rules.required]"
                            ></v-text-field>
                            <v-text-field
                                    color="secondary"
                                    label="Příjmení"
                                    v-model="form.lastName"
                                    :rules="[rules.required]"
                            ></v-text-field>
                            <v-text-field
                                    color="secondary"
                                    v-model="form.phone"
                                    v-mask="mask"
                                    label="Telefon"
                                    :rules="[rules.required]"
                                    hint="Telefon ve tvaru 123 456 789"
                                    persistent-hint
                            ></v-text-field>
                            <v-checkbox v-model="form.marketingAgreement"
                                        class="marketing-checkbox"
                                        :rules="[rules.required]"
                                        color="secondary"
                            >
                                <template v-slot:label>
                                    <div>
                                        Souhlasím se
                                        <a
                                                class="secondary--text"
                                                target="_blank"
                                                href="/files/Prohlaseni-o-zpracovani-osobnich-udaju-BCC_2020_03_25_zverejneno.pdf"
                                                @click.stop
                                        >
                                            zpracováním osobních údajů
                                        </a>
                                    </div>
                                </template>
                            </v-checkbox>
                            <div class="mt-3 text-right">
                                <vue-recaptcha
                                        ref="recaptcha"
                                        @verify="onCaptchaVerified"
                                        @expired="onCaptchaExpired"
                                        size="invisible"
                                        :loadRecaptchaScript="true"
                                        :sitekey="recaptchaKey">
                                </vue-recaptcha>
                                <v-btn large depressed color="secondary" rounded :block="$vuetify.breakpoint.xsOnly" :loading="loading" :disabled="loading" @click="submit($event)">Odeslat žádost</v-btn>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-form>
    </v-container>
      <v-snackbar
              v-model="snackbar"
              :color="color"
      >
          {{ text }}
          <v-btn
                  :timeout="6000"
                  text
                  @click="snackbar = false"
          >
              Zavřít
          </v-btn>
      </v-snackbar>
  </v-container>
</template>

<script>
    import { mask } from 'vue-the-mask'
    import VueRecaptcha from 'vue-recaptcha';

    export default {
        name: 'Form',
        directives: {
            mask,
        },
        components: { VueRecaptcha },
        data: () => ({
            text: '',
            errors: {},
            snackbar: false,
            mask: '+420 ### ### ###',
            valid: false,
            color: '',
            rules: {
                required: value => !!value || 'Tato položka je povinná.',
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Tato položka musí být e-mailová adresa.'
                },
            },
            loading: false,
            form: {
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
                marketingAgreement: ''
            }
        }),
        computed: {
            recaptchaKey() {
                return process.env.VUE_APP_RECAPTCHA_KEY
            }
        },
        methods: {
            handleFormSubmit() {
                return false;
            },
            submit(event) {
                event.preventDefault();
                if (this.$refs.form.validate()) {
                    this.errors = {};
                    this.loading = true;
                    this.$refs.recaptcha.execute();
                }
            },
            onCaptchaVerified: function (recaptchaToken) {
              const self = this;
              self.$refs.recaptcha.reset();
              self.form.recaptchaToken = recaptchaToken;
              window.axios.put(process.env.VUE_APP_ROOT_API + process.env.VUE_APP_CREATE_CARD, self.form).then(response => {
                  this.onSuccess(response);
              }).catch(error => {this.onError(error)});
            },
            onCaptchaExpired: function () {
                this.$refs.recaptcha.reset();
            },
            onSuccess(response) { // eslint-disable-line
                this.loading = false;
                this.color = 'success';
                this.text = 'Vše v pořádku, mrkněte na email!';
                this.snackbar = true;
                this.$refs.form.reset();
            },
            onError(response) {
                const $t = this.$t.bind(this);
                if (response.data.errors) {
                    response.data.errors.forEach(element => {
                        this.errors[element.field] = $t(element.msg);
                    });
                }
                this.loading = false;
                this.color = 'error';
                this.text = 'Něco se pokazilo, zkuste to prosím později.';
                this.snackbar = true;
            }
        },
  }
</script>

<style lang="scss">
    .request-form {
        h2 {
            font-size: 43px;
            margin-bottom: 50px;
            @media #{$pixel-less-phone} {
                font-size: 31px;
            }
        }
        .form-body {
            @media #{$pixel-less-phone} {
                padding: 20px;
            }
            .marketing-checkbox {
                label {
                    font-size: 12px;
                }
            }
        }
        .grecaptcha-badge {
            z-index: 1;
        }
    }
</style>
